<div>
	<p-table class="notes-infoset-table" [value]="entries" rowHover="false" [resizableColumns]="true"
			 [scrollable]="true" scrollHeight="calc(75vh + 50px)"
			 (sortFunction)="doCustomSort($event)" [customSort]="true">

		<ng-template pTemplate="header">
			<tr>
				<th pResizableColumn pSortableColumn="name">
					Name
					<p-sortIcon field="name"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="notes">
					Notes
					<p-sortIcon field="notes"></p-sortIcon>
				</th>
				<th></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData>
			<tr (click)="viewConfig($event, rowData)">
				<td>
					<span class="uv-table-value">{{ rowData.name }}</span>
				</td>
				<td>
					<span class="uv-table-value">{{ rowData.notes }}</span>
				</td>
				<td [ngClass]="uv-table-button-column-3">
					<button type="button" class="btn btn-primary uv-table-button" title="View notes"
							(click)="viewNotes($event, rowData)"><i class="fa fa-eye"></i></button>
				</td>
			</tr>
		</ng-template>
	</p-table>

	<p-dialog [(visible)]="displayViewNotesDialog" class="view-notes-dialog" [resizable]="true"
			  [modal]="true" [style]="{'max-width': '100%'}" appendTo="body">

		<p-header>
			<span>Notes:</span>
		</p-header>

		<pre>{{notes}}</pre>

	</p-dialog>

</div>


